import { TranslationKey } from "@/utils/translationKey";

export const PARTNER_ADD_DEVICE_BASE = "/partner/add-sim";

export const PARTNER_ADD_DEVICE_TOTAL_STEPS = 4;

interface PartnerAddDeviceStep {
  step: number;
  /** Full i18n key - the rate-selection label is shared with the portal. */
  label: TranslationKey;
  description?: string;
}

export const partnerAddDeviceStepMapping: Record<string, PartnerAddDeviceStep> =
  {
    "sim-type": {
      step: 1,
      label: "partnerPortal:addDevice.steps.sim-type.label",
      description: "sim-type.description",
    },
    "rate-selection": {
      step: 2,
      label: "portal:common.stepLabels.rateSelection",
    },
    quantity: {
      step: 3,
      label: "partnerPortal:addDevice.steps.quantity.label",
      description: "quantity.description",
    },
    "personal-details": {
      step: 4,
      label: "partnerPortal:addDevice.steps.personal-details.label",
      description: "personal-details.description",
    },
  };

export const partnerAddDeviceStepPaths: Record<string, string> = {
  "sim-type": `${PARTNER_ADD_DEVICE_BASE}/1/sim-type`,
  "rate-selection": `${PARTNER_ADD_DEVICE_BASE}/2/rate-selection`,
  quantity: `${PARTNER_ADD_DEVICE_BASE}/3/quantity`,
  "personal-details": `${PARTNER_ADD_DEVICE_BASE}/4/personal-details`,
};

export const partnerAddDeviceSubsteps = [
  "sim-type",
  "rate-selection",
  "quantity",
  "personal-details",
] as const;
